import React from 'react';
import { Header } from 'widgets';
import { PageLayout } from 'shared/ui';
import styles from './privacy-policy.page.module.scss';

export const PrivacyPolicyPage: React.FC = () => {
  return (
    <PageLayout>
      <Header hideSignInButton />
      <div className={styles.page__content}>
        <h1 className={styles.content__title}>Политика конфиденциальности</h1>
        <p className={styles.content__date}>
          Дата вступления в силу: 17.06.2026
        </p>

        <section className={styles.content__section}>
          <h2>1. Общие положения</h2>
          <p>
            Настоящая Политика конфиденциальности (далее — «Политика»)
            определяет порядок обработки и защиты персональных данных
            пользователей сервиса BookUp (далее — «Сервис»), предоставляемого
            самозанятым, ИНН 212710062014 (далее — «Оператор»).
          </p>
          <p>
            Используя Сервис, Пользователь выражает свое согласие с условиями
            настоящей Политики. В случае несогласия с условиями Политики
            Пользователь должен прекратить использование Сервиса.
          </p>
        </section>

        <section className={styles.content__section}>
          <h2>2. Персональные данные, которые мы собираем</h2>
          <p>Мы можем собирать следующие категории персональных данных:</p>
          <ul>
            <li>Фамилия, имя, отчество;</li>
            <li>Номер телефона;</li>
            <li>Адрес электронной почты;</li>
            <li>Данные об аккаунте (логин, хеш пароля);</li>
            <li>Информация о бронированиях и посещениях;</li>
            <li>
              Данные, передаваемые автоматически (IP-адрес, тип браузера, файлы
              cookie).
            </li>
          </ul>
        </section>

        <section className={styles.content__section}>
          <h2>3. Цели обработки персональных данных</h2>
          <p>Персональные данные обрабатываются в следующих целях:</p>
          <ul>
            <li>Регистрация и поддержание аккаунта Пользователя;</li>
            <li>Оформление и обработка бронирований;</li>
            <li>Связь с Пользователем по вопросам оказания услуг;</li>
            <li>Улучшение качества Сервиса и пользовательского опыта;</li>
            <li>Соблюдение требований законодательства РФ.</li>
          </ul>
        </section>

        <section className={styles.content__section}>
          <h2>4. Правовые основания обработки</h2>
          <p>Обработка персональных данных осуществляется на основании:</p>
          <ul>
            <li>Согласия Пользователя на обработку персональных данных;</li>
            <li>Договора между Пользователем и Оператором;</li>
            <li>Требований законодательства Российской Федерации.</li>
          </ul>
        </section>

        <section className={styles.content__section}>
          <h2>5. Передача персональных данных третьим лицам</h2>
          <p>
            Оператор не передает персональные данные Пользователей третьим
            лицам, за исключением случаев, предусмотренных законодательством РФ,
            а также случаев, когда передача данных необходима для оказания
            услуги (например, передача данных о бронировании выбранной точке
            оказания услуг).
          </p>
        </section>

        <section className={styles.content__section}>
          <h2>6. Защита персональных данных</h2>
          <p>
            Оператор принимает необходимые организационные и технические меры
            для защиты персональных данных Пользователей от неправомерного
            доступа, уничтожения, изменения, блокирования, копирования,
            предоставления и распространения.
          </p>
        </section>

        <section className={styles.content__section}>
          <h2>7. Права Пользователя</h2>
          <p>Пользователь имеет право:</p>
          <ul>
            <li>Получать информацию об обработке своих персональных данных;</li>
            <li>
              Требовать уточнения, блокирования или уничтожения своих данных;
            </li>
            <li>Отозвать согласие на обработку персональных данных;</li>
            <li>Обжаловать действия Оператора в уполномоченном органе.</li>
          </ul>
        </section>

        <section className={styles.content__section}>
          <h2>8. Хранение данных</h2>
          <p>
            Персональные данные хранятся в течение всего срока использования
            Пользователем Сервиса, а также в течение срока, установленного
            законодательством РФ, после прекращения использования Сервиса.
          </p>
        </section>

        <section className={styles.content__section}>
          <h2>9. Контактная информация</h2>
          <p>
            По всем вопросам, связанным с обработкой персональных данных,
            Пользователь может обращаться по адресу электронной почты:
            support@book-up.ru.
          </p>
        </section>

        <section className={styles.content__section}>
          <h2>10. Изменение Политики</h2>
          <p>
            Оператор оставляет за собой право вносить изменения в настоящую
            Политику. Новая редакция Политики вступает в силу с момента ее
            публикации в Сервисе, если иное не указано в тексте изменений.
          </p>
        </section>
      </div>
    </PageLayout>
  );
};
